{
  "$schema": "https://admin.dev.restopilot360.fr/schemas/config.schema.json",

  "apiUrl": "https://admin.dev.restopilot360.fr/api",
  "appUrl": "https://dev.restopilot360.fr/",
  "redirectUri": "https://admin.dev.restopilot360.fr/auth/confirm-password"
}